import React, { useState, useCallback } from "react";
import { GoogleMap, LoadScript, OverlayView } from "@react-google-maps/api";
import locations from "../data/map.json"; // adjust path

const containerStyle = {
  width: "100%",
  height: "700px",
};

const center = {
  lat: 51.5,
  lng: -0.12,
};

const MapSection = () => {
  const [activePopup, setActivePopup] = useState(null);

  const handleMarkerClick = useCallback(
    (index) => {
      setActivePopup(index === activePopup ? null : index);
    },
    [activePopup]
  );

  return (
    <LoadScript googleMapsApiKey="AIzaSyDAZVkKhGD3Fkzzf2lxtyd3VUXWr-nryP4">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={3}
        options={{
          styles: [
            // Hide all labels
            {
              featureType: "all",
              elementType: "labels",
              stylers: [{ visibility: "off" }],
            },

            // Landscape / land
            {
              featureType: "landscape",
              elementType: "geometry.fill",
              stylers: [{ color: "#383838" }],
            },

            // Roads
            {
              featureType: "road.highway",
              elementType: "geometry.fill",
              stylers: [{ color: "#6e6e6e" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry.fill",
              stylers: [{ color: "#515151" }],
            },
            {
              featureType: "road.local",
              elementType: "geometry.fill",
              stylers: [{ color: "#4a4a4a" }],
            },

            // Water
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#000000" }],
            },

            // Hide all administrative boundaries (removes red dotted lines)
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.fill",
              stylers: [{ visibility: "off" }],
            },

            // Hide transit lines
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ visibility: "off" }],
            },
          ],
        }}
      >
        {locations.map((loc, index) => (
          <OverlayView
            key={index}
            position={{ lat: loc.lat, lng: loc.lng }}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
          >
            <div
              style={{
                cursor: loc.link.includes("NO LINK") ? "default" : "pointer", // for marker only
              }}
            >
              {/* Pulsating mappoint */}
              <div
                className="mappoint"
                onClick={() => handleMarkerClick(index)}
              />

              {/* Popup appears on click */}
              {activePopup === index && (
                <div
                  className="popup"
                  style={{
                    backgroundColor: "#ffffff",
                    padding: "12px 16px",
                    borderRadius: "4px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    color: "#000000",
                    display: "inline-block",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    cursor: "default", // force default cursor on popup
                  }}
                >
                  {/* NAME as clickable link */}
                  {loc.link.includes("NO LINK") ? (
                    <p style={{ margin: "0 0 8px 0", fontWeight: "bold" }}>
                      {loc.name}
                    </p>
                  ) : (
                    <a
                      href={loc.link}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        textDecoration: "underline",
                        marginBottom: "8px",
                        cursor: "pointer", // pointer only on the link
                      }}
                    >
                      {loc.name}
                    </a>
                  )}

                  <br />
                  <br />

                  {/* Coordinates */}
                  <p
                    style={{
                      margin: "0",
                      fontSize: "10px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {`{LAT: ${loc.lat.toFixed(4)}, LNG: ${loc.lng.toFixed(
                      4
                    )}} // ${loc.country}`}
                  </p>
                </div>
              )}
            </div>
          </OverlayView>
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapSection;
